import { pick } from 'lodash';
import { getPickupDateTime } from '../config';

const hasError = (error) => Object.values(error).filter(Boolean).length;

const isInvalidPayload = (payload) => {
  const {shipperAddress1, shipperAddress2, ...rest} = payload;
  const hasShipperAddress = Boolean(shipperAddress1 || shipperAddress2);
  return !hasShipperAddress || Object.values(rest).some((value) => !value);
}

const getDuplicatePickupCheckerParams = ({
  pickupInfo,
  selectedTerminal,
  selectedTerminalError,
  pickupErrorInfo
}) => {
  const { readyTime, closeTime, pickupDate } = getPickupDateTime(pickupInfo.pickupDateTimeInfo);
  return {
    data: {
      readyTime,
      closeTime,
      pickupDate,
      ...pick(pickupInfo.shipperInfo, [
        'shipperName',
        'shipperAddress1',
        'shipperAddress2',
        'shipperZip'
      ]),
      pickupTerminal: selectedTerminal
    },
    error: {
      ...pick(pickupErrorInfo.pickupDateTimeInfo, ['pickupDate', 'readyTime', 'closeTime']),
      ...pick(pickupErrorInfo.shipperInfo, [
        'shipperName',
        'shipperAddress1',
        'shipperAddress2',
        'shipperZip'
      ]),
      selectedTerminalError
    }
  };
};

const getPayload = (data) => {
  return {
    pickupTerminal: data.pickupTerminal,
    shipperName: data.shipperName,
    shipperAddress: data.shipperAddress1,
    shipperAddress2: data.shipperAddress2,
    shipperZip: data.shipperZip,
    pickupReadyTime: data.readyTime,
    pickupCloseTime: data.closeTime,
    pickupDate: data.pickupDate
  };
};

export { hasError, getDuplicatePickupCheckerParams, getPayload, isInvalidPayload };
